import { Component, OnInit, inject, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { MarkdownComponent } from 'ngx-markdown';
import { FeathericonsModule } from '../../icons/feathericons/feathericons.module';
import { DocsService, DocEntry } from '../../services/docs.service';

@Component({
    selector: 'app-documentacion',
    standalone: true,
    imports: [
        CommonModule,
        RouterLink,
        RouterLinkActive,
        MatCardModule,
        MatProgressSpinnerModule,
        NgScrollbarModule,
        MarkdownComponent,
        FeathericonsModule,
    ],
    templateUrl: './documentacion.component.html',
    styleUrl: './documentacion.component.scss',
})
export class DocumentacionComponent implements OnInit {
    private route = inject(ActivatedRoute);
    private router = inject(Router);
    private docsService = inject(DocsService);

    docs = signal<DocEntry[]>([]);
    loading = signal(true);
    currentId = signal<string | null>(null);
    markdownUrl = computed(() => {
        const id = this.currentId();
        if (!id) return null;
        const entry = this.docs().find((d) => d.id === id);
        return entry ? this.docsService.getMarkdownUrl(entry.file) : null;
    });

    docIcon(doc: DocEntry): string {
        if (doc.id === 'manual-tecnico') return 'file-text';
        if (doc.id === 'diccionario-datos') return 'database';
        return 'book-open';
    }

    ngOnInit(): void {
        this.route.params.subscribe((params) => {
            const id = (params['id'] as string) || null;
            this.currentId.set(id);
        });
        this.docsService.getIndex().subscribe((list) => {
            this.docs.set(list);
            this.loading.set(false);
            if (!this.currentId() && list.length > 0) {
                this.router.navigate(['/docs', list[0].id], {
                    replaceUrl: true,
                });
            }
        });
    }
}
